<template>
  <el-select
    v-model="innerVal"
    :filterable="filterable"
    remote
    clearable
    :multiple="multiple"
    :collapse-tags="collapseTags"
    :placeholder="placeholder"
    :size="size"
    :remote-method="remoteMethod"
    :loading="loading"
  >
    <el-option
      v-for=" (item,idex) in remoteOptions"
      :key="idex"
      :label="item.label"
      :value="item.value"
    >
      <template v-if="type == 'miner' || type == 'member'">
        <span style="float: left">{{ item.label }}</span>
        <span style="float: right; color: #8492a6; font-size: 13px">{{
          item.local_hashrate | hashRateFormat
        }}</span>
      </template>
    </el-option>
  </el-select>
</template>

<script>
import api from "@/interface";
import { deepCopy } from "@/utils/assist";
import { hashRateFormat, fixed8 } from "@/utils/assist";
let keyMap = new Map([
  ["senum", ["key", "title"]],
  ["gamemanage", ["_id", "title"]],
  ["idostation", ["_id", "name"]],
  ["nftStation", ["_id", "name"]],
  ["nftProject", ["_id", "name"]],
  ["settingRole", ["_id", "name"]],
  ["token", ["_id", "title"]],
  ["idoProject", ["_id", "title"]],
  ["settingStaffLog", ["model","model"]],
  ["settingHelp", ["_id", "name"]],
  ["inoStation", ["_id", "title"]],
  ["inoProject", ["_id", "name"]],


]);

export default {
  name: "cus-autocomplete",
  props: {
    size: {
      type: String,
      default: "small",
    },
    placeholder: {
      type: String,
      default: "Please Select",
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    collapseTags: {
      type: Boolean,
      default: false,
    },
    filterable: {
      type: Boolean,
      default: true,
    },
    value: {
      type: [String, Number],
    },
    type: {
      validator: function (value) {
        return keyMap.has(value);
      },
    },
    filter: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      remoteOptions: [],
      innerVal: undefined,
      loading: false,
    };
  },
  watch: {
    value(val) {
      this.innerVal = val;
    },
    innerVal(val) {
      this.$emit("input", val);
    },
    filter: {
      handler(val) {
        this.remoteMethod();
      },
      deep: true,
    },
    type: {
      handler(val) {
        this.remoteMethod();
      },
      deep: true,
    },
  },
  created() {
    let field = keyMap.get(this.type)[2];
    let queryString = "";
    if (typeof field != "undefined" && typeof this.$route.query[field] != "undefined") {
      let _id = this.$route.query[field];
      api[this.type]
        .getList({ id: _id })
        .then((res) => {
          try {
            const {
              data: { list },
            } = res;
            if (list.length == 1) {
              this.rsFormat(list);
              this.innerVal = _id;
            }
          } catch (err) {}
        })
        .finally(() => {
          this.loading = false;
        });
    } else {
      this.remoteMethod();
    }
  },
  filters: {
    hashRateFormat,
  },
  methods: {
    rsFormat(list) {
      let t = keyMap.get(this.type);
      switch (this.type) {
        case "token":
          this.remoteOptions = list.map((itm) => ({
            value: itm["_id"],
            label: itm["name"] + "(" + itm["symbol"] + ")",
          }));
          break;
        case "member":
          this.remoteOptions = list.map((itm) => ({
            value: itm[t[0]],
            label: itm[t[1]],
            local_hashrate: itm[t[3]],
          }));
          break;
        default:
          this.remoteOptions = list.map((itm) => ({
            value: itm[t[0]],
            label: itm[t[1]],
          }));
          break;
      }
    },
    remoteMethod(queryString) {
      this.loading = true;
      let filter = deepCopy(this.filter);
      filter.query = queryString;
      api[this.type]
        .getList(filter)
        .then((res) => {
          try {
            const {
              data: { list },
            } = res;
            this.rsFormat(list);
          } catch (err) {}
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
